<style scoped lang="scss">
@import '~variables';

nav {
    display: flex;
    justify-content: space-between;

    .datatable_sort_wrapper {
        position: relative;

        .sort_icon {
            position: absolute;
            line-height: 0;
            right: .25em;
            top: calc(50% - .5em);
            color: $gray-500;

            &.active {
                color: $black;
            }
        }
    }

    .per_page {
        select {
            display: inline-block;
            width: auto;
        }
    }
}
</style>

<template>
    <div v-if="search">
        <div>
            <p v-if="search.isLoading">
                {{ trans.get('datatable.loading') }}
            </p>
            <p v-if="!search.isLoading && search.pageObject.data.length === 0">
                {{ trans.get('datatable.no-results') }}
            </p>
        </div>
        <nav v-if="search.pageObject && search.pageObject.current_page">
            <ul class="pagination">
                <li class="page-item" :class="{'disabled': 1 === search.pageObject.current_page }"><a class="page-link" @click="showPage(1)"><span>&laquo;</span></a></li>
                <li class="page-item disabled" v-if="search.pageObject.current_page - padding  > 0"><span class="page-link">...</span></li>
                <li class="page-item" :class="{'active': pageNumber === search.pageObject.current_page }" v-for="pageNumber in getPages()"><a class="page-link" @click="showPage(pageNumber)">{{ pageNumber }}</a></li>
                <li class="page-item disabled" v-if="search.pageObject.current_page + padding <= search.pageObject.last_page"><span class="page-link">...</span></li>
                <li class="page-item" :class="{'disabled': search.pageObject.last_page === search.pageObject.current_page }"><a class="page-link" @click="showPage(search.pageObject.last_page)"><span>&raquo;</span></a></li>
            </ul>

            <div>
                <span class="per_page form-group">
                    <label for="per_page">{{ trans.get('datatable.per_page') }}</label>
                    <select class="form-control" v-model="search.perPage" @input="perPageChanged()" id="per_page">
                        <option v-for="item in search.perPageOptions" :value="item">{{ item }}</option>
                    </select>
                </span>
                <span class=" ml-4">
                    {{ search.pageObject.to }} of {{ search.pageObject.total }}
                </span>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {

        props: {
            search: Object,
            padding: {
                type: Number,
                default: 3
            },
        },

        methods: {

            getPages() {
                let startPage = this.search.pageObject.current_page - this.padding;
                startPage = startPage < 1 ? 1 : startPage;

                let lastPage = this.search.pageObject.current_page + this.padding;
                lastPage = lastPage > this.search.pageObject.last_page ? this.search.pageObject.last_page : lastPage;

                const totalPages = lastPage - startPage;

                return Array.from(Array(totalPages + 1).keys()).map(function(item) { return item + startPage; });
            },

            showPage(pageNumber) {
                this.search.gotoPage(pageNumber);
            },

            perPageChanged() {
                setTimeout(this.search.search);
            }
        }
    }
</script>
